import { CssBaseline, ThemeProvider } from '@mui/material';
import { useRoutes } from 'react-router-dom';
import 'nprogress/nprogress.css';
import routes from "./routes";
import { SettingsConsumer, SettingsProvider } from './contexts/settings-context';
import { createTheme } from "./theme";
import useAuth from './hooks/useAuth';
import SplashScreen from './components/SplashScreen';
import { useEffect } from 'react';

function App() {
  const content = useRoutes(routes);

  const auth = useAuth();

  // Function to clear complete cache data
  const clearCacheData = () => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
    console.log('cache data eliminada')
  };

  useEffect(() => {
    clearCacheData()
  }, [])

  return (
    <SettingsProvider>
      <SettingsConsumer>
        {({ settings }) => (
          <ThemeProvider
            theme={createTheme({
              direction: settings.direction,
              responsiveFontSizes: settings.responsiveFontSizes,
              mode: settings.theme
            })}
          >
            <CssBaseline />
            {auth.isInitialized ? content : <SplashScreen />}
          </ThemeProvider>
        )}
      </SettingsConsumer>
    </SettingsProvider>
  );
}

export default App;
